import { z } from 'zod'
import interceptedAxios from '../../../../utils/interceptedAxios'
import { type CreateHybridKekPostRequest, ZHSMHybridKek } from '../../types'

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZHSMHybridKek,
  error: z.boolean()
})

export type CreateGroupHybridKekApiResponse = z.infer<typeof ZHSMHybridKek>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createHybridKek (
  CreateHybridKekPostRequest: CreateHybridKekPostRequest,
  onSuccess: (successResponse: CreateGroupHybridKekApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/app-config-service/api/v1/crypto/hybrid-kek'

  interceptedAxios
    .post(url, CreateHybridKekPostRequest)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        // istanbul ignore else
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
